module.exports = __webpack_public_path__ + "img/32_30.a0e3002a.png";